import { Route, Switch } from 'react-router-dom';

import SSOCreate from './SSOCreate';
import SSOEdit from './SSOEdit';
import SSOFailedAttempts from './SSOFailedAttempts';
import SSOList from './SSOList';

export default function SSOSettings() {
	return (
		<Switch>
			<Route path="/settings/integrations/sso" exact>
				<SSOList />
			</Route>
			<Route path="/settings/integrations/sso/create" exact>
				<SSOCreate />
			</Route>
			<Route path="/settings/integrations/sso/logs" exact>
				<SSOFailedAttempts />
			</Route>
			<Route path="/settings/integrations/sso/:id" exact>
				<SSOEdit />
			</Route>
		</Switch>
	);
}
